/* PAYMENT */
// New link
export const GETTING_NEW_LINK = 'GETTING_NEW_LINK'
export const SET_NEW_LINK_ERRORS = 'SET_NEW_LINK_ERRORS'
export const SAVE_NEW_PAYMENT_LINK = 'SAVE_NEW_PAYMENT_LINK'
export const RESET_NEW_PAYMENT_LINK = 'RESET_NEW_PAYMENT_LINK'

// Cancel Link
export const SET_USER_STATE_AFTER_CANCEL = 'SET_USER_STATE_AFTER_CANCEL'
export const RESET_CANCEL_LINK = 'RESET_CANCEL_LINK'
export const SET_CANCEL_LINK_ERRORS = 'SET_CANCEL_LINK_ERRORS'
export const CANCELLING_LINK = 'CANCELLING_LINK'

// Custom Payment
export const UPDATE_CUSTOM_PAYMENT_DATA = 'UPDATE_CUSTOM_PAYMENT_DATA'
export const RESET_CUSTOM_PAYMENT = 'RESET_CUSTOM_PAYMENT'
export const SET_CUSTOM_PAYMENT_ERRORS = 'SET_CUSTOM_PAYMENT_ERRORS'
export const GETTING_CUSTOM_PAYMENT_LINK = 'GETTING_CUSTOM_PAYMENT_LINK'

/* PASSENGERS */
export const GETTING_USER_PASSENGERS = 'GETTING_USER_PASSENGERS'
export const SET_USER_PASSENGERS = 'SET_USER_PASSENGERS'
export const SET_USER_PASSENGERS_ERRORS = 'SET_USER_PASSENGERS_ERRORS'

/* ADDRESS */
export const GETTING_USER_ADDRESS = 'GETTING_USER_ADDRESS'
export const SET_USER_ADDRESS = 'SET_USER_ADDRESS'
export const SET_USER_ADDRESS_ERRORS = 'SET_USER_ADDRESS_ERRORS'

/* SEARCH */
export const SET_ACTIVE_SEARCH_PRODUCT = 'SET_ACTIVE_SEARCH_PRODUCT'
export const CREATE_SEARCH_PRODUCTS = 'CREATE_SEARCH_PRODUCTS'
export const RESET_SEARCH_PLUGIN = 'RESET_SEARCH_PLUGIN'

// Flight
export const SHOW_FLIGHT_SEARCHER = 'SHOW_FLIGHT_SEARCHER'
export const UPDATE_FLIGHT_QUERY = 'UPDATE_FLIGHT_QUERY'
export const SENDING_FLIGHT_QUERY = 'SENDING_FLIGHT_QUERY'
export const SEARCHING_FLIGHT = 'SEARCHING_FLIGHT'
export const GETTING_FLIGHT_RESULTS = 'GETTING_FLIGHT_RESULTS'
export const SET_FLIGHT_SEARCH_RESULTS = 'SET_FLIGHT_SEARCH_RESULTS'
export const SELECT_FLIGHT_RESULT = 'SELECT_FLIGHT_RESULT'
export const TOGGLE_FLIGHT_RESULT_DETAILS = 'TOGGLE_FLIGHT_RESULT_DETAILS'
export const CLEAR_FLIGHT_RESULTS = 'CLEAR_FLIGHT_RESULTS'
export const SHOW_FLIGHT_FILTERS = 'SHOW_FLIGHT_FILTERS'
export const UPDATE_FLIGHT_FILTERS = 'UPDATE_FLIGHT_FILTERS'
export const SHOW_FLIGHT_SORTER = 'SHOW_FLIGHT_SORTER'
export const UPDATE_FLIGHT_SORT = 'UPDATE_FLIGHT_SORT'
export const CANCEL_FLIGHT_SEARCH = 'CANCEL_FLIGHT_SEARCH'

// Hotel
export const SHOW_HOTEL_SEARCHER = 'SHOW_HOTEL_SEARCHER'
export const UPDATE_HOTEL_QUERY = 'UPDATE_HOTEL_QUERY'
export const SENDING_HOTEL_QUERY = 'SENDING_HOTEL_QUERY'
export const SEARCHING_HOTEL = 'SEARCHING_HOTEL'
export const GETTING_HOTEL_RESULTS = 'GETTING_HOTEL_RESULTS'
export const SET_HOTEL_SEARCH_RESULTS = 'SET_HOTEL_SEARCH_RESULTS'
export const SELECT_HOTEL_RESULT = 'SELECT_HOTEL_RESULT'
export const TOGGLE_HOTEL_RESULT_DETAILS = 'TOGGLE_HOTEL_RESULT_DETAILS'
export const CLEAR_HOTEL_RESULTS = 'CLEAR_HOTEL_RESULTS'
export const SHOW_HOTEL_FILTERS = 'SHOW_HOTEL_FILTERS'
export const UPDATE_HOTEL_FILTERS = 'UPDATE_HOTEL_FILTERS'
export const SHOW_HOTEL_SORTER = 'SHOW_HOTEL_SORTER'
export const UPDATE_HOTEL_SORT = 'UPDATE_HOTEL_SORT'
export const CANCEL_HOTEL_SEARCH = 'CANCEL_HOTEL_SEARCH'

/* LOCATOR */
export const SENDING_LOCATOR = 'SENDING_LOCATOR'
export const UPDATE_LOCATOR = 'UPDATE_LOCATOR'
export const SET_LOCATOR_ERRORS = 'SET_LOCATOR_ERRORS'

/* VIRTUAL ASSISTANT */
export const SET_IS_OPEN = 'SET_IS_OPEN'


/* TRACKING USER INFO */
export const DISPLAY_TRACKING_USER_INFO = 'DISPLAY_TRACKING_USER_INFO'
export const UPDATE_TRACKING_USER_INFO = 'UPDATE_TRACKING_USER_INFO'

/* TRACKING USER HISTORY */
export const DISPLAY_TRACKING_USER_HISTORY = 'DISPLAY_TRACKING_USER_HISTORY'
export const UPDATE_TRACKING_USER_HISTORY = 'UPDATE_TRACKING_USER_HISTORY'

/* SHARED FILES */
export const DISPLAY_SHARED_RESOURCES = 'DISPLAY_SHARED_RESOURCES'
export const UPDATE_SHARED_RESOURCES = 'UPDATE_SHARED_RESOURCES'
export const SELECT_SHARED_RESOURCES_TO_DOWNLOAD = 'SELECT_SHARED_RESOURCES_TO_DOWNLOAD'

/* TOPIC SUMMARY */
export const DISPLAY_TOPIC_SUMMARY_INFO = 'DISPLAY_TOPIC_SUMMARY_INFO'
export const UPDATE_TOPIC_SUMMARY_INFO = 'UPDATE_TOPIC_SUMMARY_INFO'
